<template>
    <div class="modal fade" id="static-deletion-massive" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-md-dhk">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title w-100">
                        <h2 class="mt-0 title--1" v-html="title ? title : ' Are you sure you want to delete?'" />
                        <h3 class="subtitle--1">
                            Confirmation
                        </h3>
                    </div>
                    <div class="modal__description">
                        <p class="modal__description__text my-3" v-if="message"> 
                            {{message}}
                        </p>
                        <p v-else>
                            Once you delete these records, they will be moved to the Recycle Bin. You can recover them from there within the next 30 days. After that, the records will be permanently removed.
                        </p>
                    </div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <img width="15px" src="/assets/img/svg/close.svg" alt="Imagen de una equis">
                    </button>
                </div>
                <div class="modal__buttons mt-0 text-center text-md-right">
                    <button type="button" data-dismiss="modal" class="modal__buttons__item cancel">Cancel</button>
                    <button type="button" class="modal__buttons__item" @click="event_emition()">Yes</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    name:   'DeletionMassiveModal',
    
    props:  [
        'title',
        'message'
    ],

    methods:{
        event_emition(){
            this.$emit('objectDeletion', true);
        }
    },

    mounted(){

    }
}
</script>